module.exports = __webpack_public_path__ + "img/homePageRe.56bd7999.svg";